export default __webpack_public_path__ + "static/media/Foto11.3e6a1413.png";